/**
 * Possible states for payment objects returned from BOP.
 */
export const paymentStates = {
  BALANCE_DUE: 'BalanceDue',
  CREDIT_OWED: 'CreditOwed',
  FAILED: 'Failed',
  PAID: 'Paid',
  PENDING: 'Pending',
};

/**
 * Possible paymentMethod values for payment objects returned from BOP.
 */
export const paymentMethods = {
  MULTIBANCO: 'multibanco',
};
